/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_ComparingInputs */

const en_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparing...`)
};

const de_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich...`)
};

const fr_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparaison...`)
};

const es_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparando...`)
};

const it_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronto...`)
};

const nl_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijken...`)
};

const pl_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównywanie...`)
};

const fi_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaillaan...`)
};

const da_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenligner...`)
};

const sv_salary_compare_comparing = /** @type {(inputs: Salary_Compare_ComparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför...`)
};

/**
* | output |
* | --- |
* | "Comparing..." |
*
* @param {Salary_Compare_ComparingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_comparing = /** @type {((inputs?: Salary_Compare_ComparingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_ComparingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_comparing(inputs)
	if (locale === "fr") return fr_salary_compare_comparing(inputs)
	if (locale === "es") return es_salary_compare_comparing(inputs)
	if (locale === "it") return it_salary_compare_comparing(inputs)
	if (locale === "nl") return nl_salary_compare_comparing(inputs)
	if (locale === "pl") return pl_salary_compare_comparing(inputs)
	if (locale === "fi") return fi_salary_compare_comparing(inputs)
	if (locale === "da") return da_salary_compare_comparing(inputs)
	if (locale === "sv") return sv_salary_compare_comparing(inputs)
	return en_salary_compare_comparing(inputs)
});